import { createTheme } from '@mui/material/styles';

const themeConfig = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#FF7500',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#25221E',
    },
    success: {
      main: '#059669',
    },
    error: {
      main: '#EF4444',
    },
    info: {
      main: '#9CA3AF',
    },
    background: {
      default: 'rgba(255, 255, 255, 0.75)',
    },
  },
  typography: {
    fontFamily: 'Karla, sans-serif',
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#EF4444',
          '&.Mui-disabled': {
            color: '#EF4444',
          },
        },
      },
    },
  },
});

export default themeConfig;
